<template>
<!-- This example requires Tailwind CSS v2.0+ -->
<div class="fixed z-10 inset-0 overflow-y-auto" :class="showModal?'':'hidden'" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <div class="inline-block align-bottom bg-gray-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-7xl sm:w-full">

    <section class="border border-gray-800 p-3">
        <div class="flex justify-between">
            <h4 class="text-white text-sm font-bold uppercase mb-3">Create {{ featureName }} feature</h4>
            <span v-if="$page.props.errors" v-for="err in Object.values($page.props.errors)" class="errormessage font-bold">{{ err }}</span>
            <button type="button" class="close" @click.prevent="closeModal">
              <span>&times;</span>
            </button>
        </div>
    </section>

    <div class="flex lang-box mt-5">
        <a v-for="(lang, index) in languages" href="#" @click.prevent="changeLanguage(lang)" :key="index"
        :class="{active:(form.current_language == lang), disabled:langDisabled(lang)}">{{ showFallbackLang(lang) }}</a>
    </div>
    <CreateFileInsidePanoramaFeatureSection
    :form="form" :saveFile="saveFile"

    :currentFileType="form.current_filetype"
    @update:currentFileType="newValue => form.current_filetype = newValue"

    :withAudio="form.with_audio"
    @update:withAudio="newValue => form.with_audio = newValue"

    :audioLoop="form.feature_files.audio_files.info.loop"
    @update:audioLoop="newValue => form.feature_files.audio_files.info.loop = newValue"

    :audioVolume="form.feature_files.audio_files.info.volume"
    @update:audioVolume="newValue => form.feature_files.audio_files.info.volume = newValue"

    :changeUploadBoxState="changeUploadBoxState"

    :langDisabled="langDisabled"
    />

    </div>
  </div>
</div>
</template>

<script>
import CreateFileInsidePanoramaFeatureSection from '@/Pages/Station/Partials/Features/Panorama/CreateFileInsidePanoramaFeatureSection';
import { showFallbackLang } from '@/Pages/GlobalHelpers';

export default {
    components: {
        CreateFileInsidePanoramaFeatureSection,
    },
    props: ['showModal', 'closeModal', 'featureName', 'changeUploadBoxState', 'form'],
    data(){
        return {
            languages: this.$page.props.tour.data.languages,
        }
    },
    mounted(){
        this.changeLanguage(this.$page.props.tour.data.fallback_language);
    },
    updated(){
        //=========filetypes
        let currentFileType;
        if(this.form.current_filetype == 'panorama_image'){
            currentFileType = 'panorama_image'
        }
        if(this.form.current_filetype == 'panorama_video'){
            currentFileType = 'panorama_video'
        }
        this.form.feature_files.panorama_files.file_type = currentFileType;
        //=========filetypes
    },
    methods: {
        saveFile() {
            this.form.post(route('panoramafeature.store', this.$page.props.station.data.id), {
              preserveScroll: true,
              onSuccess: () => this.closeModal(),
            });
        },
        changeLanguage(lang){
            this.form.loaded_file_path = '';
            this.form.from_media_library_id = false;
            if(this.langDisabled(lang))
            {
                return;
            }
            this.form.current_language = lang;
        },
        langDisabled(lang){
            if(lang == this.form.current_language)
            {
                return false;
            }
            if(this.form.feature_files.panorama_files.languages[this.form.fallback_language].file != null)
            {
                return false;
            }
            if(this.form.feature_files.panorama_files.languages[this.form.fallback_language].loaded_file_path.length > 0)
            {
                return false;
            }
            return true;
        },
        showFallbackLang:showFallbackLang
    }
}
</script>
